<template>
    <div v-if="addon.Id" class="service-package-warning-content">
        <p>
            {{ t({ key: 'warning.we_recommend_basic_service_package', suffix: '.' }) }}
        </p>
        <p>
            {{ t({ key: 'warning.do_you_want_basic_service_package' }) }}
        </p>
        <p v-if="price">
            <span class="service-package-warning-content-price">
                {{ price }}
            </span>
            {{ t({ key: 'warning.for_the_entire_booking' }) }}
        </p>
    </div>
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, onMounted, PropType } from 'vue';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { ServicePackageAddon } from '@/api/Cart/cart.interfaces';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';
    import { logStatsigCheckoutServicePackageWarningOpen } from '@/tracking/statsig/checkout.functions';

    export default defineComponent({
        name: 'ServicePackageWarning',
        methods: { t, getMoneyObjectAsString },
        props: {
            addon: {
                type: Object as PropType<ServicePackageAddon>,
                required: true,
            },
        },
        setup(props) {
            onMounted(() => {
                trackClarity(ClarityEvent.CHECKOUT_SERVICE_PACKAGE_WARNING);
                logStatsigCheckoutServicePackageWarningOpen();
            });

            const price = computed(() => getMoneyObjectAsString(props.addon.Price));

            return { price };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'ServicePackageWarning';
</style>
